import defaultApi from '@/utils/request';

export default {
  // ============================== S45W2001 ==================================
  // S45W2001 導師評量作業
  // 取得導師評量作業資料
  S419W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S419/S419W2001_Load',
      params,
    });
  },
  S419W2001_TeacherViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S419/S419W2001_TeacherViewLoad',
      params,
    });
  },
  S419W2001_QuestionViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S419/S419W2001_QuestionViewLoad',
      params,
    });
  },
  S419W2001_QuestionViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S419/S419W2001_QuestionViewAction',
      data,
    });
  },

};
